import { render, staticRenderFns } from "./budgetEdit.vue?vue&type=template&id=97ef9198&scoped=true&"
import script from "./budgetEdit.vue?vue&type=script&lang=js&"
export * from "./budgetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ef9198",
  null
  
)

export default component.exports